import { Checkbox } from 'rsuite';
import './ProjectRightsChecklist.css';

// Short names for a member's rights on their chip.
export const RIGHT_SHORT = {
  manage: 'Manage',
  finance: 'Finance',
  disciplines: 'Disciplines',
};

/**
 * A member's rights on one project, one checkbox each with what it grants. None ticked means they
 * can view the project. Rights the signed-in user doesn't hold here can't be given or taken away,
 * so they show as they are, locked.
 */
export default function ProjectRightsChecklist({ rights, value, onChange, grantable, disabled }) {
  const held = new Set(value);
  const allowed = new Set(grantable);
  const set = (key, on) => onChange(rights.map((r) => r.key).filter((k) => (k === key ? on : held.has(k))));

  return (
    <div className="ppc-rights">
      {rights.map((r) => (
        <Checkbox
          key={r.key}
          checked={held.has(r.key)}
          disabled={disabled || !allowed.has(r.key)}
          onChange={(_v, checked) => set(r.key, checked)}
          className="ppc-rights__item"
        >
          <span className="ppc-rights__label">{r.label}</span>
          <span className="ppc-rights__desc">{r.description}</span>
        </Checkbox>
      ))}
      <div className="ppc-rights__note">
        {held.size === 0 ? 'With none ticked they can view this project.' : 'Everyone on the project can view it.'}
        {rights.some((r) => !allowed.has(r.key)) ? ' You can only give or take away permissions you hold here.' : ''}
      </div>
    </div>
  );
}
